import { draggableGroups } from 'features/list/constants.json'
import { utils } from 'gipsy-misc'

import get from 'lodash/get'

export const onMouseEnter = function() {
  this.isInsideDraggableList = true
}

export const onMouseLeave = function() {
  this.isInsideDraggableList = false
}

export const onDragStart = function(data, cancelFunction) {
  cancelFunction()
  utils.DOM.disableScroll()
  this.setState({
    dragging: true
  })
}

/*
 ** we do that to avoid setting dragging to false when task is drop inside a draggable list :
 ** if dropped inside, it will call onDropComplete which will move the task
 ** if we set dragging to false before this action is done, it will show the list empty for a few ms which breaks the UI
 ** (const height = (list && list.length > 0) || dragging ? 'auto' : 1) height would be 1 when we want 'auto'
 */
export const onDragEnd = function() {
  if (!this.isInsideDraggableList) {
    this.setState({
      dragging: false
    })
  }
  utils.DOM.enableScroll()
}

/* onDrop is called invidually by each DraggableList, so we need to process concat each result before completing the process */
export const onDrop = function(result, dragAndDropCallback) {
  this.dropResults = this.dropResults || []
  this.dropResults.push(result)

  if (this.dropResults.length >= draggableGroups.length) {
    this.onDropComplete(this.dropResults, dragAndDropCallback)
    this.dropResults = []
  }
  return
}

export const onDropComplete = async function(results, dragAndDropCallback) {
  this.dropResults = []

  const id = get(results, '[0].payload.item.id')
  if (!id) {
    console.error('item dragged and dropped not found')
    this.setState({ dragging: false })
    return
  }
  let actionParam = {
    id,
    from: null,
    to: null
  }

  for (const result of results) {
    if (result.removedIndex !== null) {
      actionParam.from = { table: result.group, index: result.removedIndex }
    }
    if (result.addedIndex !== null) {
      actionParam.to = { table: result.group, index: result.addedIndex }
    }
    if (actionParam.from && actionParam.to) {
      break
    }
  }

  if (!actionParam.from || !actionParam.to) {
    console.error('results incomplete to perform drag&drop actions')
    this.setState({ dragging: false })
    return
  }
  this.setState({ dragging: false })
  await dragAndDropCallback(actionParam)
}



// WEBPACK FOOTER //
// ./src/features/draganddrop/utils.js